import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { compact } from 'lodash';
import { FileThumbnail } from '@unite-us/client-utils';
import SurveyJSFormRenderer from '@unite-us/surveyjs/dist/components/Renderer/SurveyJSFormRenderer';
import { callbacks, getAdapter, hooks } from '../../../config/api';
import { PrimaryButton, SecondaryButton } from '../../common/TailwindComponents';
export var EnrollmentReview = function EnrollmentReview(_ref) {
  var _plan$metafields;
  var contactId = _ref.contactId,
    groupId = _ref.groupId,
    currentEmployee = _ref.currentEmployee,
    fetchRecentUpdates = _ref.fetchRecentUpdates,
    form = _ref.form,
    formResponse = _ref.formResponse,
    plan = _ref.plan,
    primaryInsuranceId = _ref.primaryInsuranceId,
    attachedDocuments = _ref.attachedDocuments,
    stepBackward = _ref.stepBackward,
    stepForward = _ref.stepForward;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    submitting = _useState2[0],
    setSubmitting = _useState2[1];
  var surveyRef = useRef();
  var metafields = (_plan$metafields = plan === null || plan === void 0 ? void 0 : plan.metafields) !== null && _plan$metafields !== void 0 ? _plan$metafields : [];
  var submissionJson = {
    responses: formResponse,
    form: form === null || form === void 0 ? void 0 : form.id,
    provider: groupId,
    contextType: 'person',
    context: contactId,
    submitter: currentEmployee
  };
  var handleSetSurvey = function handleSetSurvey(survey) {
    surveyRef.current = survey;
  };
  var invalidateQueries = hooks.useInvalidateQueries();
  var _hooks$useCreateRecor = hooks.useCreateRecord('form_submission', {
      api: 'coreApi'
    }),
    createFormSubmission = _hooks$useCreateRecor.createRecord;
  var _hooks$useCreateRecor2 = hooks.useCreateRecord('enrollment_request'),
    createEnrollmentRequest = _hooks$useCreateRecor2.createRecord;
  var _hooks$useUpdateRecor = hooks.useUpdateRecord('enrollment_request'),
    updateEnrollmentRequest = _hooks$useUpdateRecor.updateRecord;
  var addFileUploadsToEnrollmentRequest = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(enrollmentRequest, files) {
      var metadata;
      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            metadata = _mapInstanceProperty(files).call(files, function (file) {
              var _context;
              return {
                field: file.field,
                value: _mapInstanceProperty(_context = file.value).call(_context, function (fileEntry) {
                  return fileEntry.id;
                })
              };
            });
            _context2.next = 3;
            return updateEnrollmentRequest(enrollmentRequest, {
              metadata: metadata
            }, {
              mutationConfig: {
                onSuccess: function onSuccess() {
                  callbacks.toast.success('Enrollment Request Sent.');
                }
              }
            });
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee);
    }));
    return function addFileUploadsToEnrollmentRequest(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var uploadFiles = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(enrollmentRequestId) {
      return _regeneratorRuntime.wrap(function _callee4$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", _Promise.all(_mapInstanceProperty(attachedDocuments).call(attachedDocuments, /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
                var field, _ref4$value, value, uploadFileResponses;
                return _regeneratorRuntime.wrap(function _callee3$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      field = _ref4.field, _ref4$value = _ref4.value, value = _ref4$value === void 0 ? [] : _ref4$value;
                      uploadFileResponses = _mapInstanceProperty(value).call(value, /*#__PURE__*/function () {
                        var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref6) {
                          var _response$data;
                          var file, response;
                          return _regeneratorRuntime.wrap(function _callee2$(_context3) {
                            while (1) switch (_context3.prev = _context3.next) {
                              case 0:
                                file = _ref6.file;
                                _context3.next = 3;
                                return getAdapter('coreApi').uploadFile('enrollment_requests', enrollmentRequestId, file);
                              case 3:
                                response = _context3.sent;
                                return _context3.abrupt("return", response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data);
                              case 5:
                              case "end":
                                return _context3.stop();
                            }
                          }, _callee2);
                        }));
                        return function (_x5) {
                          return _ref7.apply(this, arguments);
                        };
                      }());
                      _context4.t0 = field;
                      _context4.t1 = compact;
                      _context4.next = 6;
                      return _Promise.all(uploadFileResponses);
                    case 6:
                      _context4.t2 = _context4.sent;
                      _context4.t3 = (0, _context4.t1)(_context4.t2);
                      return _context4.abrupt("return", {
                        field: _context4.t0,
                        value: _context4.t3
                      });
                    case 9:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee3);
              }));
              return function (_x4) {
                return _ref5.apply(this, arguments);
              };
            }())));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee4);
    }));
    return function uploadFiles(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var submit = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var survey, _createResponse$data$, _createResponse$data, createResponse, enrollmentRequest, uploadFilesResponse;
      return _regeneratorRuntime.wrap(function _callee5$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            survey = surveyRef.current;
            if (!(survey.completeLastPage() && !survey.hasErrors())) {
              _context6.next = 19;
              break;
            }
            setSubmitting(true);
            _context6.next = 5;
            return createEnrollmentRequest({
              person: contactId,
              plan: plan.id,
              request_type: 'enroll',
              primary_health_insurance_id: primaryInsuranceId
            }, {
              mutationConfig: {
                onError: function onError() {
                  return callbacks.toast.error('Something went wrong.');
                }
              }
            });
          case 5:
            createResponse = _context6.sent;
            enrollmentRequest = (_createResponse$data$ = createResponse === null || createResponse === void 0 || (_createResponse$data = createResponse.data) === null || _createResponse$data === void 0 ? void 0 : _createResponse$data.data) !== null && _createResponse$data$ !== void 0 ? _createResponse$data$ : {};
            if (!enrollmentRequest.id) {
              _context6.next = 13;
              break;
            }
            _context6.next = 10;
            return uploadFiles(enrollmentRequest.id);
          case 10:
            uploadFilesResponse = _context6.sent;
            _context6.next = 13;
            return addFileUploadsToEnrollmentRequest(enrollmentRequest.id, uploadFilesResponse);
          case 13:
            _context6.next = 15;
            return createFormSubmission(submissionJson, {
              mutationConfig: {
                onError: function onError() {
                  return callbacks.toast.error('Something went wrong.');
                }
              }
            });
          case 15:
            setSubmitting(false);
            invalidateQueries();
            fetchRecentUpdates();
            stepForward();
          case 19:
          case "end":
            return _context6.stop();
        }
      }, _callee5);
    }));
    return function submit() {
      return _ref8.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "p-4 pt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 pt-0"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-md mb-4"
  }, "Review the information to make sure it is correct before requesting enrollment."), /*#__PURE__*/React.createElement("div", {
    className: "bg-white py-4 flex items-center justify-start space-x-6"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SurveyJSFormRenderer, {
    formData: {
      configuration: form.configuration
    },
    formSubmission: submissionJson,
    editMode: false,
    handleSetSurveyModel: handleSetSurvey
  }), /*#__PURE__*/React.createElement("div", {
    className: "pt-2"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg text-dark-blue font-medium-font mb-4 leading-7"
  }, "Supporting Documents"), _mapInstanceProperty(attachedDocuments).call(attachedDocuments, function (documents) {
    var _context8;
    return /*#__PURE__*/React.createElement("div", {
      className: "row",
      key: documents.field
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-sm-6 flex justify-start mt-1"
    }, /*#__PURE__*/React.createElement("p", {
      className: "payments-attachments-metafield-header uppercase font-heavy-font text-xs tracking-wider"
    }, _mapInstanceProperty(metafields).call(metafields, function (meta) {
      var _context7;
      return _includesInstanceProperty(_context7 = _Object$values(meta)).call(_context7, documents.field) && documents.value ? meta.label : null;
    }))), documents.value ? _mapInstanceProperty(_context8 = documents.value).call(_context8, function (fileEntry, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6 flex justify-end",
        key: fileEntry.tempId
      }, /*#__PURE__*/React.createElement("div", {
        className: "preview-item flex",
        key: 'filepreview-'.concat(index)
      }, /*#__PURE__*/React.createElement(FileThumbnail, {
        size: 18,
        color: "#4467AB",
        contentType: fileEntry.file.type
      }), /*#__PURE__*/React.createElement("div", {
        className: "file-name pl-1 pb-4"
      }, /*#__PURE__*/React.createElement("a", {
        href: "".concat(fileEntry.preview),
        rel: "noreferrer",
        target: "_blank",
        className: "payments-attachments-metafield-header text-xs tracking-wider whitespace-no-wrap"
      }, fileEntry.file.name))));
    }) : null);
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "bg-white px-6 py-4 flex items-center justify-end space-x-6"
  }, /*#__PURE__*/React.createElement(SecondaryButton, {
    label: "Previous",
    "data-testid": "submit-enrollment-request-previous-button",
    onClick: stepBackward,
    disabled: submitting
  }), /*#__PURE__*/React.createElement(PrimaryButton, {
    id: "submitButton",
    label: "Submit enrollment request",
    "data-testid": "submit-enrollment-request",
    disabled: submitting,
    onClick: submit
  })));
};
EnrollmentReview.propTypes = {
  form: PropTypes.object.isRequired,
  formResponse: PropTypes.array.isRequired,
  contactId: PropTypes.string.isRequired,
  currentEmployee: PropTypes.string.isRequired,
  attachedDocuments: PropTypes.array.isRequired,
  groupId: PropTypes.string.isRequired,
  plan: PropTypes.object.isRequired,
  stepForward: PropTypes.func.isRequired,
  stepBackward: PropTypes.func.isRequired,
  fetchRecentUpdates: PropTypes.func.isRequired,
  primaryInsuranceId: PropTypes.string
};
//# sourceMappingURL=EnrollmentReview.js.map